import moment from "moment";

export function isOptionalAndWithNoAmount(row) {
    if (row?.optional) {
        if (!row.subRows?.length) {
            // pas de condition sur les netAmounts ou les monthly (pas besoin pour le moment/à voir plus tard si l'utilisation se généralise)
            return true;
        }
    }
    return false;
}

export function getPercentageOfTotal(row, table, pi, key = "netAmounts") {
    const lastTotal = table.rows[table.rows.length - 1];
    const total = lastTotal[key][pi];
    if (total === 0) {
        return 0;
    } else {
        const result = row[key][pi] / total;
        return result * 100;
    }
}

export function statSheetNotOnly6And7(AccountableAccountFilter: string): boolean {
    const ranges = AccountableAccountFilter.split(" OR ");
    for (let r of ranges) {
        r = r.replace(/AA\.name.? = '/i, "");
        if (["1", "2", "3", "4", "5", "8", "9"].includes(r[0])) {
            return true;
        }
    }
    return false;
}

export interface dashboardTableOptions {
    aaListToGroupByAaDescription?: Array<string>;
    aaListNotToGroup?: Array<string>;
    computeNetAmounts2?: boolean;
}

const defaultAAListNotToGroup = ["455"];

export class DashBoardTable {
    tables = [];
    periods = [];
    customAmounts = {};
    keyRows = {};
    accountingPeriodId = "";
    initializeDone: boolean = false;
    displayDetails: boolean = false;

    aaListToGroupByAaDescription: any[] = undefined;
    aaListNotToGroup: any[] = undefined;
    computeNetAmounts2: boolean = undefined;

    constructor(
        periods,
        tables = [],
        accountingPeriodId = "",
        customAmounts = {},
        options: dashboardTableOptions = {}
    ) {
        this.periods = periods;
        this.tables = tables;
        this.accountingPeriodId = accountingPeriodId;
        this.customAmounts = customAmounts;

        this.aaListToGroupByAaDescription = options.aaListToGroupByAaDescription; // not used for the moment (06/2024)
        this.aaListNotToGroup = options.aaListNotToGroup || defaultAAListNotToGroup || null;
        this.computeNetAmounts2 = options.computeNetAmounts2 || undefined;
    }

    get monthlyPeriodIndex() {
        return this.periods.findIndex((p) => p.monthly);
    }

    async initializeData() {
        if (!this.initializeDone) {
            this.initializeDone = true;

            // if(!this.customAmounts || _.isEmpty(this.customAmounts)) {
            await this.unstreamCustomAmounts(this.accountingPeriodId);
            // }

            if (this.periods?.length) {
                // let pi:number = 0
                for (const period of this.periods) {
                    if (period.monthly) {
                        period.monthCount =
                            moment(period.end).diff(moment(period.start), "month") + 1;
                        if (period.monthCount > 0) {
                            period.monthIndices = [];
                            let currentMonth = moment(period.start);
                            for (let mi = 0; mi < period.monthCount; mi++) {
                                period.monthIndices.push({
                                    month: currentMonth.month(),
                                    year: currentMonth.year(),
                                });
                                currentMonth = currentMonth.add(1, "month");
                            }
                            // this.monthlyPeriod = period
                            // this.monthlyPeriodIndice = pi
                            if (!this.computeNetAmounts2) {
                                break;
                            }
                            // break;
                        } else {
                            period.monthCount = 0;
                            period.monthly = false;
                            debugger;
                        }
                    }
                    // pi++
                }
            }
            this.initializeTable();
            this.generateCellKeys();
        }
    }

    initializeTable() {
        for (const table of this.tables) {
            for (const row of table.rows) {
                this.initializeRow(table.columns, row);
            }
        }
    }

    get monthlyPeriodIndice() {
        let index = 0;
        for (const period of this.periods) {
            if (period.monthly) {
                return index;
            }
            index++;
        }
        return undefined;
    }

    get monthlyPeriod() {
        for (const period of this.periods) {
            if (period.monthly) {
                return period;
            }
        }
        return undefined;
    }

    initializeRow(columns, row, isSubRow: boolean = false) {
        if (!row) {
            debugger; // git-ignore
            return;
        }
        if (!isSubRow && !row.name && !row.total) {
            return;
        }
        // this._initializeRow(table.columns, row)
        for (const col of columns) {
            row[col.key] = new Array(this.periods.length).fill(0.0);
        }
        if (this.monthlyPeriod) {
            //maxime to change
            row.monthlyAmounts = {};
            for (const col of columns) {
                row.monthlyAmounts[col.key] = new Array(this.monthlyPeriod.monthCount).fill(0);
                // netAmounts2
                row.monthlyAmounts[col.key + "2"] = [];
                for (const p of this.periods) {
                    row.monthlyAmounts[col.key + "2"].push(
                        new Array(this.monthlyPeriod.monthCount).fill(0)
                    );
                }
            }
        }
        if (row.subRows && row.subRows.length) {
            for (const col of columns) {
                for (const subRow of row.subRows) {
                    subRow.values[col.key] = new Array(this.periods.length).fill(0.0);
                }
            }
        }
    }

    // _initializeRow(columns, row) {
    //     for (const col of columns) {
    //         row[col.key] = new Array(this.periods.length).fill(0.0);
    //     }
    //     if (this.monthlyPeriod) {
    //         row.monthlyAmounts = {};
    //         for (const col of columns) {
    //             row.monthlyAmounts[col.key] = new Array(this.monthlyPeriod.monthCount).fill(0);
    //         }
    //     }
    // }

    addConditionKey(name, aas) {
        aas.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
        //
        let key = name + ":";
        let aaKeys = "";
        for (const aa of aas) {
            if (aaKeys) aaKeys += "#";
            aaKeys += aa;
        }
        key += aaKeys;
        return key;
    }

    generateCellKeys() {
        for (const table of this.tables) {
            for (const row of table.rows) {
                if (!row) {
                    continue;
                }
                if (row.key) {
                    for (const col of table.columns) {
                        if (!row.columnKeys) {
                            row.columnKeys = {};
                        }
                        row.columnKeys[col.key] = row.key + "-" + col.key;
                    }
                } else if (row.columns) {
                    for (const colKey in row.columns) {
                        const conditions = row.columns[colKey];
                        if (!conditions?.length) {
                            continue;
                        }
                        let keys = [];
                        for (const condition of conditions) {
                            //
                            // sort
                            //
                            let key = "";
                            if (condition.equalTo) {
                                if (key) key += "-";
                                key += this.addConditionKey("equalTo", condition.equalTo);
                            }
                            if (condition.startsWith) {
                                if (key) key += "-";
                                key += this.addConditionKey("startsWith", condition.startsWith);
                            }
                            if (condition.notStartsWith) {
                                if (key) key += "-";
                                key += this.addConditionKey(
                                    "notStartsWith",
                                    condition.notStartsWith
                                );
                            }
                            //
                            //
                            //
                            if (condition.debitOnly) {
                                key += "-debitOnly";
                            }
                            if (condition.creditOnly) {
                                key += "-creditOnly";
                            }
                            keys.push(key);
                        }

                        keys.sort((a, b) => {
                            if (a < b) return -1;
                            if (a > b) return 1;
                            return 0;
                        });
                        const key = keys.join("OR");

                        if (!row.columnKeys) {
                            row.columnKeys = {};
                        }
                        row.columnKeys[colKey] = key;
                    }
                }
            }
        }
    }

    initializeCol(table, colKey) {
        for (const row of table.rows) {
            if (!row.name && !row.total) {
                continue;
            }
            row[colKey] = new Array(this.periods.length).fill(0.0);
            if (row.subRows) {
                for (const subRow of row.subRows) {
                    subRow.values[colKey] = new Array(this.periods.length).fill(0.0);
                }
            }
        }
    }

    build() {
        //
        // reset total
        //
        for (const table of this.tables) {
            for (const row of table.rows) {
                if (row.keys || row.previousAmount) {
                    this.initializeRow(table.columns, row);
                }
            }
        }
        //
        // additionalOperations (used only in balance sheet (bilan))
        //
        let colKeys = {};
        for (const table of this.tables) {
            for (const column of table.columns) {
                const key = column.key;
                if (column.additionalOperations) {
                    for (const additionalOperation of column.additionalOperations) {
                        const colKey = additionalOperation.key;
                        if (!colKeys[colKey]) {
                            this.initializeCol(table, colKey);
                            colKeys[colKey] = true;
                        }
                    }
                }
            }
        }
        for (const table of this.tables) {
            for (const column of table.columns) {
                const key = column.key;
                if (column.additionalOperations) {
                    //!  made to allow amountPersonalisation on balanceSheet but netAmount result is double its real value and this feature is not used actually
                    for (const additionalOperation of column.additionalOperations) {
                        const otherKey = additionalOperation.key;
                        for (const row of table.rows) {
                            if (row[key] && row[otherKey]) {
                                // row[otherKey][pi] += additionalOperation.sign * row[key][pi]
                                if (row.subRows) {
                                    for (const subRow of row.subRows) {
                                        if (subRow.values) {
                                            if (!subRow.values[key]) {
                                                subRow.values[key] = new Array(
                                                    this.periods.length
                                                ).fill(0.0);
                                            }
                                            // if ( !subRow.values[otherKey]) {
                                            //     subRow.values[otherKey] = new Array(this.periods.length).fill(0.0)
                                            // }
                                            for (let pi = 0; pi < this.periods.length; pi++) {
                                                subRow.values[otherKey][pi] +=
                                                    additionalOperation.sign *
                                                    this.getSubRowAmount(row, subRow, key, pi); //subRow.values[key][pi]
                                            }
                                        } else {
                                            debugger;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        //
        // create dictionary keys
        //
        this.keyRows = {};
        for (const table of this.tables) {
            for (const row of table.rows) {
                if (row.key) {
                    this.keyRows[row.key] = row;
                }
            }
        }

        //
        // compute subRows totals and row from subRows
        //
        for (const table of this.tables) {
            for (const row of table.rows) {
                // const totalSubrow = {}
                if (row.subRows?.length) {
                    for (const col of table.columns) {
                        if (!row[col.key]) {
                            debugger;
                            console.error({
                                type: "error",
                                message: "undefined col key in row col.key =" + col.key,
                            });
                            row[col.key] = new Array(this.periods.length).fill(0.0);
                            // continue
                        }
                        // totalSubrow[col.key] = new Array(this.periods.length).fill(0.0)
                        for (let pi = 0; pi < this.periods.length; pi++) {
                            let total = 0;
                            for (const subrow of row.subRows) {
                                if (subrow.values?.[col.key]?.[pi] !== undefined) {
                                    total += subrow.values[col.key][pi];
                                } else {
                                    subrow.values[col.key] = new Array(this.periods.length).fill(
                                        0.0
                                    );
                                    debugger;
                                    console.error({
                                        type: "error",
                                        message:
                                            "undefined col key in row col.key =" +
                                            col.key +
                                            " pi= " +
                                            pi,
                                    });
                                }

                                // totalSubrow[col.key][pi] += subrow.values?.[col.key]?.[pi] || 0
                            }
                            row[col.key][pi] = total;
                        }
                    }
                }
            }
        }

        //
        // compute subtotal
        //
        for (const table of this.tables) {
            const subTotalRow: any = { total: true };
            this.initializeRow(table.columns, subTotalRow);
            let startIndex = 0;
            let index = 0;
            for (const row of table.rows) {
                if (row.name && !row.marginRatio) {
                    for (let pi = 0; pi < this.periods.length; pi++) {
                        // values
                        for (const col of table.columns) {
                            subTotalRow[col.key][pi] += this.getAmount(row, col.key, pi); //row[col.key][pi]
                        }
                    }
                    // monthly values
                    if (subTotalRow.monthlyAmounts && row.monthlyAmounts) {
                        for (const col of table.columns) {
                            const values = row.monthlyAmounts[col.key];
                            if (values?.length) {
                                for (let mi = 0; mi < values.length; mi++) {
                                    // const value = values[mi]
                                    // if (value) {
                                    //     subTotalRow.monthlyAmounts[col.key][mi] += value
                                    // }
                                    subTotalRow.monthlyAmounts[col.key][mi] +=
                                        this.getMonthlyAmount(
                                            row,
                                            col.key,
                                            this.monthlyPeriodIndex,
                                            mi
                                        );
                                }
                            }
                        }
                    }
                }

                if (row.total && row.previousAmount) {
                    for (let pi = 0; pi < this.periods.length; pi++) {
                        // values
                        for (const col of table.columns) {
                            row[col.key][pi] = subTotalRow[col.key][pi];
                        }
                    }
                    // monthly values
                    if (subTotalRow.monthlyAmounts && row.monthlyAmounts) {
                        for (const col of table.columns) {
                            const values = subTotalRow.monthlyAmounts[col.key];
                            if (values?.length) {
                                for (let mi = 0; mi < values.length; mi++) {
                                    const value = values[mi];
                                    if (value) {
                                        row.monthlyAmounts[col.key][mi] = value;
                                    }
                                }
                            }
                        }
                    }

                    if (
                        table.relativePercentage >= 0 &&
                        table.relativePercentage < table.columns.length
                    ) {
                        const col = table.columns[table.relativePercentage];
                        for (let pri = startIndex; pri < index; pri++) {
                            const prevRow = table.rows[pri];
                            prevRow.relativePercentages = new Array(this.periods.length).fill(0.0);

                            for (let pi = 0; pi < this.periods.length; pi++) {
                                if (subTotalRow[col.key][pi]) {
                                    if (prevRow[col.key]) {
                                        const prevValue = this.getAmount(prevRow, col.key, pi);
                                        const subValue = this.getAmount(subTotalRow, col.key, pi);
                                        prevRow.relativePercentages[pi] =
                                            (100 * prevValue) / subValue;
                                    }
                                    // else {
                                    //     debugger
                                    // }
                                }
                            }
                        }
                        startIndex = index + 1;
                    }
                    this.initializeRow(table.columns, subTotalRow);
                }
                if (row.total && !row.previousAmount) {
                    this.initializeRow(table.columns, subTotalRow);
                }
                index++;
            }
        }

        // compute total
        for (const table of this.tables) {
            for (const row of table.rows) {
                // if (row.total && (row.type === "fromKeys")) {
                if (row.keys) {
                    for (const key of row.keys) {
                        const keyRow = this.keyRows[key];
                        if (!keyRow) {
                            // debugger
                            continue;
                        }
                        // values
                        for (let pi = 0; pi < this.periods.length; pi++) {
                            for (const col of table.columns) {
                                row[col.key][pi] += this.getAmount(keyRow, col.key, pi);
                            }
                        }
                        // monthly values
                        if (row.monthlyAmounts && keyRow.monthlyAmounts) {
                            for (const col of table.columns) {
                                const values = keyRow.monthlyAmounts[col.key];
                                if (values?.length) {
                                    for (let mi = 0; mi < values.length; mi++) {
                                        row.monthlyAmounts[col.key][mi] += this.getMonthlyAmount(
                                            keyRow,
                                            col.key,
                                            this.monthlyPeriodIndex,
                                            mi
                                        );
                                    }
                                }
                            }
                        }
                    }
                }
                // }
            }
        }

        //
        // re compute total from monthly values
        //
        if (this.monthlyPeriodIndice >= 0) {
            for (const table of this.tables) {
                for (const row of table.rows) {
                    if (!row.marginRatio && row.monthlyAmounts) {
                        for (const col of table.columns) {
                            if (!this.isCustomAmount(row, col.key, this.monthlyPeriodIndex)) {
                                row[col.key][this.monthlyPeriodIndice] = 0;
                                const valueCount = row.monthlyAmounts[col.key].length;
                                for (let mi = 0; mi < valueCount; mi++) {
                                    row[col.key][this.monthlyPeriodIndice] += this.getMonthlyAmount(
                                        row,
                                        col.key,
                                        this.monthlyPeriodIndice,
                                        mi
                                    );
                                }
                            }
                        }
                    }
                }
            }
        }

        //
        // marginRatio
        //
        for (const table of this.tables) {
            for (const row of table.rows) {
                if (row.marginRatio && row.input && row.input.key1 && row.input.key2) {
                    const key1Row = this.keyRows[row.input.key1];
                    const key2Row = this.keyRows[row.input.key2];
                    if (!key1Row || !key2Row) {
                        // debugger;
                        continue;
                    }
                    // values
                    for (let pi = 0; pi < this.periods.length; pi++) {
                        for (const col of table.columns) {
                            if (!this.isCustomAmount(row, col.key, pi)) {
                                const key2Value = this.getAmount(key2Row, col.key, pi);
                                if (key2Value) {
                                    const key1Value = this.getAmount(key1Row, col.key, pi);
                                    row[col.key][pi] = -(key1Value / key2Value);
                                }
                            }
                        }
                    }
                    // monthly values
                    if (key1Row.monthlyAmounts && key2Row.monthlyAmounts && row.monthlyAmounts) {
                        for (const col of table.columns) {
                            const values = row.monthlyAmounts[col.key];
                            for (let mi = 0; mi < values.length; mi++) {
                                if (
                                    !this.isCustomAmount(row, col.key, this.monthlyPeriodIndex, mi)
                                ) {
                                    const key2Value = this.getMonthlyAmount(
                                        key2Row,
                                        col.key,
                                        this.monthlyPeriodIndex,
                                        mi
                                    );
                                    if (key2Value) {
                                        const key1Value = this.getMonthlyAmount(
                                            key1Row,
                                            col.key,
                                            this.monthlyPeriodIndex,
                                            mi
                                        );
                                        values[mi] = -(key1Value / key2Value);
                                    } else {
                                        values[mi] = null;
                                    }
                                }
                            }
                        }
                    }
                }
                // }
            }
        }
        //
        // comparison
        //
        if (this.periods.length) {
            for (const table of this.tables) {
                if (table.comparison) {
                    if (this.periods.length !== 2) {
                        table.comparison.difference = false;
                        table.comparison.percentage = false;
                        continue;
                    }
                    const comparison = table.comparison;

                    if (comparison.index >= 0 && comparison.index < table.columns.length) {
                        const colKey = table.columns[comparison.index].key;
                        for (const row of table.rows) {
                            if (row.name || row.total) {
                                const key0Value = this.getAmount(row, colKey, 0);
                                const key1Value = this.getAmount(row, colKey, 1);
                                const difference = key0Value - key1Value;
                                if (comparison.difference) {
                                    row.difference = difference;
                                }
                                if (comparison.percentage && key1Value) {
                                    row.percentage = (100.0 * difference) / key1Value;
                                }
                            }
                        }
                    } else {
                        debugger;
                    }
                }
            }
        }

        for (const table of this.tables) {
            for (const row of table.rows) {
                if (row.subRows?.length) {
                    row.subRows.sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    });
                }
            }
        }

        return {
            output: {
                periods: this.periods,
                tables: this.tables,
            },
        };
    }

    async resetAllCustomAmounts() {
        this.customAmounts = {};
        await this.resetAllStreamCustomAmounts();
        this.build();
    }

    // getKey(rowKey, colKey, pi:number, mi:number = undefined) {
    //     let key = rowKey + "-" + colKey  + "-" + pi
    //     if (mi !== undefined && mi >= 0) {
    //         key += "_" + mi
    //     }
    //     return key
    // }

    getKey(row, colKey, pi: number, mi: number = undefined, subRowName = undefined) {
        if (!row.columnKeys) {
            // debugger
            return "";
        }
        let key = row.columnKeys[colKey] + "-" + pi;
        if (subRowName) {
            key = "subRow:" + subRowName + "-" + row.columnKeys[colKey] + "-" + pi;
        }
        if (mi !== undefined && mi >= 0) {
            key += "-" + mi;
        }
        const period = this.periods[pi];
        if (period.budgetId) {
            key += "-budgetId:" + period.budgetId;
        } else if (period.type === "freeBudget") {
            key += "-freeBudget";
        }
        key +=
            "-period:" +
            moment(period.start).format("YYYY-MM") +
            "-" +
            moment(period.end.substring(0, 10)).format("YYYY-MM");
        return key;
    }

    isCustomAmount(row, colKey, pi: number, mi: number = undefined, subRowName = undefined) {
        const key = this.getKey(row, colKey, pi, mi, subRowName);
        if (key) {
            const customAmount = this.customAmounts[key];
            return customAmount !== undefined && customAmount !== null;
        }
        return false;
    }

    async resetCustomAmount(row, colKey, pi: number, mi: number = undefined) {
        const result = await this._resetCustomAmount(row, colKey, pi, mi);
        if (result) {
            this.build();
        }
    }
    async _resetCustomAmount(row, colKey, pi: number, mi: number = undefined) {
        const key = this.getKey(row, colKey, pi, mi);
        if (key && this.customAmounts[key]) {
            await this.removeStreamCustomAmount(key);
            const customAmount = this.customAmounts[key];
            if (customAmount.impactedCells && customAmount.impactedCells.length) {
                for (const impactedCell of customAmount.impactedCells) {
                    await this._resetCustomAmount(
                        impactedCell.row,
                        impactedCell.colKey,
                        impactedCell.pi,
                        impactedCell.mi
                    );
                }
            }
            delete this.customAmounts[key];
            return true;
        }
        return false;
    }

    async setCustomAmount(cell) {
        const customAmont = await this._setCustomAmount(cell);
        if (customAmont) {
            this.build();
        }
    }

    async _setCustomAmount(cell) {
        const subRowName = cell.subrow ? cell.subrow.name : undefined;
        const key = this.getKey(cell.row, cell.colKey, cell.pi, cell.mi, subRowName);
        if (!key) {
            debugger; // git-ignore
            return null;
        }

        await this.streamCustomAmount(key, cell.value);

        // this.customAmounts[key] = cell.value
        let customAmount = this.customAmounts[key];
        if (customAmount) {
            customAmount.value = cell.value;
        } else {
            customAmount = {
                previousValue: cell.previousValue,
                value: cell.value,
                modified: true,
            };
            this.customAmounts[key] = customAmount;
        }
        // onCellModified()
        const row = cell.row;
        if (row.marginRatio && row.input && row.input.key1 && row.input.key2 && row.input.modify) {
            const margin = cell.value;
            const key2Row = this.keyRows[row.input.key2];
            const key1Row = this.keyRows[row.input.key1];
            if (row.input.modify === "key1") {
                let key2Value = 0;
                if (cell.mi === undefined) {
                    key2Value = key2Row[cell.colKey][cell.pi];
                } else {
                    key2Value = key2Row.monthlyAmounts[cell.colKey][cell.mi];
                    //netAmounts2
                    //key2Value = key2Row.monthlyAmounts[cell.colKey][cell.pi][cell.mi];
                }
                if (key2Value) {
                    const key1Cell = JSON.parse(JSON.stringify(cell));
                    key1Cell.row = key1Row;
                    key1Cell.value = -(key2Value * margin); // -(margin * key2Value + key2Value)
                    await this._setCustomAmount(key1Cell);
                    if (!customAmount.impactedCells) {
                        customAmount.impactedCells = [];
                    }
                    customAmount.impactedCells.push(key1Cell);
                }
            } else if (row.input.modify === "key2") {
                let key1Value = 0;
                if (cell.mi === undefined) {
                    key1Value = key1Row[cell.colKey][cell.pi];
                } else {
                    key1Value = key1Row.monthlyAmounts[cell.colKey][cell.mi];
                    // netAmounts2
                    //key2Value = key2Row.monthlyAmounts[cell.colKey][cell.pi][cell.mi];
                }
                const key2Cell = JSON.parse(JSON.stringify(cell));
                key2Cell.row = key2Row;
                key2Cell.value = -(key1Value / margin); // -key1Value / (margin + 1)
                await this._setCustomAmount(key2Cell);
                if (!customAmount.impactedCells) {
                    customAmount.impactedCells = [];
                }
                customAmount.impactedCells.push(key2Cell);
            }
        }

        return customAmount;
    }

    getAmountFromRowKey(rowKey, colKey, pi) {
        const row = this.keyRows[rowKey];
        if (row) {
            return this.getAmount(row, colKey, pi);
        }
        debugger; // git-ignore
        return "X";
    }

    getAmount(row, colKey, pi) {
        const key = this.getKey(row, colKey, pi);
        if (key) {
            const customAmount = this.customAmounts[key];
            if (customAmount !== undefined) {
                return customAmount.value;
            }
        }
        if (row.subRows?.length) {
            return row.subRows.reduce(
                (result, currentValue) =>
                    result + this.getSubRowAmount(row, currentValue, colKey, pi),
                0
            );
        }
        if (row[colKey] !== undefined) {
            return row[colKey][pi];
        }

        console.error("ERROR col.key undefined in row key=" + colKey);
        return "X";
    }

    getMonthlyAmount(row, colKey, pi: number, mi: number) {
        const key = this.getKey(row, colKey, pi, mi);
        if (key) {
            const customAmount = this.customAmounts[key];
            if (customAmount !== undefined) {
                return customAmount.value;
            }
        }

        if (row.monthlyAmounts?.[colKey] && mi < row.monthlyAmounts?.[colKey].length) {
            const amount = row.monthlyAmounts[colKey][mi];
            //netAmounts2
            // const amount = row.monthlyAmounts[colKey][pi][mi];
            return amount;
        }
        debugger;
        return "X";
    }

    getSubRowAmount(row, subRow, colKey, pi) {
        if (!subRow?.name) {
            console.error("ERROR subRow.name undefined in row=" + row);
            return "X";
        }
        const key = this.getKey(row, colKey, pi, undefined, subRow.name);
        if (key) {
            const customAmount = this.customAmounts[key];
            if (customAmount !== undefined) {
                return customAmount.value;
            }
        }
        if (row[colKey] !== undefined && subRow?.values?.[colKey]?.[pi] !== undefined) {
            return subRow.values[colKey][pi];
        }
        debugger;
        console.error("ERROR col.key or subRow.values undefined in row key=" + colKey);
        return "X";
    }

    getSubRowMonthlyAmount(row, subRow, colKey, pi, mi) {
        // ** pi = period index - mi = month index
        // ** subrow is detailled accountableAccount with monthlyAmounts (array of numbers)
        if (!subRow?.name) {
            console.error("ERROR subRow.name undefined in row=" + row);
            return "X";
        }
        const key = this.getKey(row, colKey, pi, mi, subRow.name);
        if (key) {
            const customAmount = this.customAmounts[key];
            if (customAmount !== undefined) {
                return customAmount.value;
            }
        }

        if (row[colKey] !== undefined && subRow?.monthlyAmounts?.[colKey]?.[mi] !== undefined) {
            const amount = subRow.monthlyAmounts[colKey][mi];
            //netAmounts2
            // const amount = subRow.monthlyAmounts[colKey][pi][mi];
            return amount;
        }
        debugger;
        return "X";
    }

    async streamCustomAmount(key, value) {}

    async removeStreamCustomAmount(key) {}

    async resetAllStreamCustomAmounts() {}

    isCellEditable(row, pi) {
        if (!row) return false;
        if (row.editable) return true;
        if (row.previousAmount || row.keys) return false;
        if (this.periods[pi].type === "freeBudget") return true;
        return false;
    }

    async unstreamCustomAmounts(accountingPeriodId) {}

    //
    // get balance
    //
    // async getBalances(tags, partitionTags) {

    //     const range = this.getRange()
    //     await this.initializeData() // move 2 last functions
    //     await this.collectData()
    // }

    //
    // computation
    //

    // async compute3(tags, partitionTags) {
    //     await this.initialize()
    //     this.tables = await this.getTables()
    //     const range = this.getRange()
    //     const tables = this.tables

    //     await this.initializeData()

    //     await this.collectData()

    //     await this.computeWithBalances(tables)
    //     return this.finishComputation(tables)
    // }

    async collectData() {}

    async initialize() {}
    async finishComputation(
        tables: any
    ): Promise<{ output: { periods: any[]; tables: any; customAmounts: {} } }> {
        return {
            output: {
                periods: this.periods,
                tables,
                customAmounts: this.customAmounts,
            },
        };
    }

    async computeWithBalances(tables) {
        let monthCount: number = 0;
        let monthly: boolean = false;
        let monthlyDone: boolean = false;
        for (const period of this.periods) {
            if (period.monthly) {
                monthly = true;
                monthCount = period.monthCount;
                if (!this.computeNetAmounts2) {
                    break;
                }
                // break;
            }
        }

        for (let pi = 0; pi < this.periods.length; pi++) {
            const period = this.periods[pi];
            if (period.type === "freeBudget") {
                continue;
            }
            const balances = period.balances;
            if (!balances?.length) {
                // debugger
                console.error("no balances for period= ", pi);
                continue;
            }

            for (const balance of balances) {
                // if(balance.name.startsWith('401')) { debugger }
                if (!balance.amountSigned || Math.abs(balance.amountSigned) <= 1e-2) {
                    continue;
                }
                let count = 0;
                for (const table of tables) {
                    for (const row of table.rows) {
                        if (!row.subRows) {
                            row.subRows = [];
                        }
                        if (row.columns) {
                            for (const key in row.columns) {
                                if (!row[key]) {
                                    debugger;
                                    continue;
                                }

                                const matchResult = this.simpleMatchConditions(
                                    balance.name,
                                    row.columns[key]
                                );
                                if (matchResult) {
                                    const result = {
                                        amount: 0.0,
                                    };
                                    this.setAmount(
                                        result,
                                        matchResult.debitOnly,
                                        matchResult.creditOnly,
                                        balance
                                    );
                                    const groupByAaDescription =
                                        this.isGroupByAaDescription(balance);
                                    if (
                                        groupByAaDescription &&
                                        !monthly &&
                                        matchResult &&
                                        (matchResult.creditOnly || matchResult.debitOnly)
                                    ) {
                                        let sumAADescription = 0;
                                        for (const ba of balances) {
                                            if (ba.name === balance.name) {
                                                sumAADescription += ba.amountSigned;
                                            }
                                        }
                                        if (
                                            (sumAADescription < 0 && matchResult.creditOnly) ||
                                            (sumAADescription > 0 && matchResult.debitOnly)
                                        ) {
                                            result.amount = sumAADescription;
                                        } else {
                                            result.amount = 0.0;
                                        }
                                    }

                                    if (result.amount) {
                                        if (!count) {
                                            let subRow = row.subRows
                                                ? row.subRows.find((sR) =>
                                                      this.subRowGroupByCondition(sR, balance)
                                                  )
                                                : undefined;

                                            if (
                                                groupByAaDescription &&
                                                !monthly &&
                                                matchResult &&
                                                (matchResult.creditOnly || matchResult.debitOnly) &&
                                                subRow?.values[key]
                                            ) {
                                                result.amount = 0.0;
                                            }
                                            row[key][pi] += result.amount;
                                            let monthIndice = -1;
                                            if (!monthlyDone && period.monthly) {
                                                monthIndice = period.monthIndices.findIndex(
                                                    (mi) =>
                                                        mi.month === balance.month &&
                                                        mi.year == balance.year
                                                );
                                            }
                                            if (monthIndice >= 0) {
                                                row.monthlyAmounts[key][monthIndice] +=
                                                    result.amount;
                                                //netAmounts2
                                                row.monthlyAmounts[key + "2"][pi][monthIndice] +=
                                                    result.amount;
                                            }
                                            // let subRow = row.subRows ? row.subRows.find(e => e.name === balance.name && e.description === balance.description) : undefined

                                            if (!subRow) {
                                                subRow = {
                                                    name: balance.name,
                                                    description: groupByAaDescription
                                                        ? balance.aaDescription
                                                        : balance.description ||
                                                          balance.aaDescription,
                                                    aaDescription: balance.aaDescription,
                                                    values: {},

                                                    bankAccountName: groupByAaDescription
                                                        ? undefined
                                                        : balance.bankAccountName,
                                                    thirdPartyCompanyName: groupByAaDescription
                                                        ? undefined
                                                        : balance.thirdPartyCompanyName,
                                                    userId: groupByAaDescription
                                                        ? undefined
                                                        : balance.userId,
                                                    // monthlyAmounts : new Array(12).fill((0.0))
                                                };
                                                // if(groupByAaDescription) { subRow.groupByAaDescription = true }
                                                row.subRows.push(subRow);
                                            }
                                            if (!subRow.values[key]) {
                                                subRow.values[key] = new Array(
                                                    this.periods.length
                                                ).fill(0.0);
                                            }
                                            if (monthly && !subRow.monthlyAmounts) {
                                                subRow.monthlyAmounts = {};
                                            }
                                            if (monthly && !subRow.monthlyAmounts[key]) {
                                                subRow.monthlyAmounts[key] = new Array(
                                                    monthCount
                                                ).fill(0);
                                                //netAmounts2
                                                // subRow.monthlyAmounts[key] = new Array(
                                                //     this.periods.length
                                                // ).fill(new Array(monthCount).fill(0));
                                            }
                                            subRow.values[key][pi] += result.amount;
                                            if (monthIndice !== -1) {
                                                try {
                                                    subRow.monthlyAmounts[key][monthIndice] +=
                                                        result.amount;
                                                    //netAmounts2
                                                    // subRow.monthlyAmounts[key][pi][monthIndice] +=
                                                    //     result.amount;
                                                } catch (err) {
                                                    console.error(err);
                                                }
                                            }
                                        } else {
                                            console.warn(
                                                "🚀 - computeWithBalances - already added in table aa = ",
                                                balance.name
                                            );
                                        }
                                        count++;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!count) {
                    console.warn("computeWithBalances - not included in table aa = ", balance.name);
                    // debugger
                }
            }
            if (period.monthly && !this.computeNetAmounts2) {
                monthlyDone = true;
            }
        }
    }

    isGroupByAaDescription(balance): boolean {
        if (!this.aaListToGroupByAaDescription && !this.aaListNotToGroup) {
            return false;
        } else if (
            !this.aaListToGroupByAaDescription ||
            this.aaListToGroupByAaDescription.some((e) => balance.name.startsWith(e))
        ) {
            if (
                this.aaListNotToGroup &&
                this.aaListNotToGroup.some((e) => balance.name.startsWith(e))
            ) {
                return false;
            }
        }
        return true;
    }

    subRowGroupByCondition(sR, balance) {
        if (this.isGroupByAaDescription(balance)) {
            return sR.name === balance.name && sR.aaDescription === balance.aaDescription;
        }
        return sR.name === balance.name && sR.description === balance.description;
    }

    //! Maxime to delete ?
    prepareComputation(aaStartWith: []) {
        // transform an array of string into table   each string is a startsWith number
        const rows = [];
        for (const aaNumber of aaStartWith) {
            if (aaNumber) {
            }
        }

        return [
            {
                name: "temporary",
                columns: [
                    {
                        name: "",
                        key: "netAmounts",
                    },
                ],
                comparison: {
                    index: 0,
                    difference: true,
                    percentage: true,
                },
                rows: rows,
            },
        ];
    }

    simpleMatchConditions(accountableAccount, conditions) {
        if (!conditions) {
            debugger; // git-ignore
            return null;
        }
        if (conditions.length !== undefined) {
            if (conditions.length === 0) {
                return null;
            } else {
                for (const subConditions of conditions) {
                    let debitOnly = false;
                    let creditOnly = false;
                    if (!subConditions) {
                        debugger; // git-ignore
                        continue;
                    }
                    for (const type in subConditions) {
                        if (type === "creditOnly") {
                            creditOnly = subConditions[type];
                        } else if (type === "debitOnly") {
                            debitOnly = subConditions[type];
                        }
                    }
                    // for (const type in subConditions) {
                    if (subConditions.equalTo) {
                        const aas = subConditions.equalTo;
                        for (const aa of aas) {
                            if (!aa) continue;
                            if (accountableAccount.startsWith(aa)) {
                                //this.setAmount(result, debitOnly, creditOnly, balance)
                                //return result
                                return {
                                    debitOnly,
                                    creditOnly,
                                };
                            }
                        }
                    }
                    if (subConditions.startsWith) {
                        const aas = subConditions.startsWith;
                        for (const aa of aas) {
                            if (!aa) continue;
                            if (accountableAccount.startsWith(aa)) {
                                // combine with notStartsWith?
                                if (subConditions.notStartsWith) {
                                    const aas = subConditions.notStartsWith;
                                    for (const aa of aas) {
                                        if (!aa) continue;
                                        if (accountableAccount.startsWith(aa)) {
                                            // return null;
                                            return false;
                                        }
                                    }
                                }
                                //this.setAmount(result, debitOnly, creditOnly, balance)
                                //return result
                                return {
                                    debitOnly,
                                    creditOnly,
                                };
                            }
                        }
                    } else {
                        debugger;
                    }
                }
            }
        } else if (conditions.OR) {
            debugger;
        }
        // debugger
        return null;
    }

    _setAmount(result, amount, balance) {
        result.amount = amount;
        if (balance.subRows) {
            result.subRows = [];
            for (const subRow of balance.subRows) {
                result.subRows.push({
                    tagName: subRow.tagName,
                    amount: subRow.amountSigned,
                });
            }
        }
    }

    setAmount(result, debitOnly, creditOnly, balance) {
        const amount = balance.amountSigned;
        if (creditOnly) {
            if (amount < 0) {
                this._setAmount(result, amount, balance);
            }
        } else if (debitOnly) {
            if (amount > 0) {
                this._setAmount(result, amount, balance);
            }
        } else {
            this._setAmount(result, amount, balance);
        }
    }
}
